<template>
  <div class="subscribe-wrap">
    <van-nav-bar @click-left="clickBack" title="拜访预约" left-arrow>
    </van-nav-bar>

    <div class="form-wrap">
      <van-field name="uploader" label="识别头像" size="large" required center>
        <template #input>
          <van-uploader
            v-model="curFileList"
            :after-read="afterReadCur"
            :before-delete="beforeDelCur"
            :max-count="1"
            multiple
            capture="camera"
          >
            <img
              src="@/assets/images/avatar.png"
              alt=""
              style="width: 2.75rem; height: 2.75rem;"
            />
          </van-uploader>
        </template>
      </van-field>
      <van-field
        v-model="singleQuery.initiatorName"
        label="姓名"
        placeholder="请输入姓名"
        size="large"
        required
      />
      <van-field
        v-model="singleQuery.visitorPhone"
        label="手机号"
        placeholder="请输入手机号码"
        size="large"
        required
      />

      <van-field
        v-model="singleQuery.acceptName"
        label="被访人"
        placeholder="请选择被访人"
        size="large"
        clickable
        required
        readonly
      />
      <van-field
        v-model="singleQuery.visitorBeginTime"
        label="拜访时间"
        placeholder="点击选择"
        clickable
        readonly
        required
        is-link
        @click="clickTime('starttime')"
        size="large"
      />
      <van-field
        v-model="singleQuery.visitorEndTime"
        label="离开时间"
        placeholder="点击选择"
        clickable
        readonly
        is-link
        required
        @click="singleQuery.visitorBeginTime && clickTime('endtime')"
        size="large"
      />
      <van-field
        v-model="singleQuery.visitorIdCrde"
        :required="senseIDStatus"
        label="身份证号码"
        placeholder="请输入身证号码"
        size="large"
      />
      <van-field
        v-model="singleQuery.affiliatedUnit"
        label="所属单位"
        placeholder="请输入所属单位"
        size="large"
      />

      <van-field
        v-model="singleQuery.carNumber"
        label="车牌号"
        placeholder="请输入车牌号"
        size="large"
      />
      <van-field name="radio" label="预约事由" size="large">
        <template #input>
          <van-radio-group
            v-model="singleQuery.visitorGoal"
            direction="horizontal"
            @change="changeRadioType"
          >
            <van-radio
              :name="item.dictLabel"
              v-for="item in work"
              style="margin-bottom: 0.5rem;"
              :key="item.dictLabel"
              >{{ item.dictLabel }}</van-radio
            >
            <!-- <van-radio name="访友">访友</van-radio>
            <van-radio name="">其他</van-radio> -->
          </van-radio-group>
        </template>
      </van-field>
      <div>
        <van-field
          type="textarea"
          placeholder="请输入备注"
          label="备注"
          v-model="singleQuery.remark"
          size="large"
        ></van-field>
      </div>
    </div>
    <!-- 添加同行人员 -->
    <!-- <div>
      <div
        class="add-person-wrap"
        @click="showPersonPopup = true"
        v-if="personList.length <= 1"
      >
        <span class="iconfont">&#xe69f;</span>
        <span>添加同行人员</span>
      </div>
      <div class="person-list" v-if="personList.length > 1">
        <div class="person-header">
          <span>同行人员</span>
          <div @click="showPersonPopup = true">
            <span class="iconfont">&#xe69f;</span> <span>添加同行人员</span>
          </div>
        </div>
        <div
          class="person-item flex flex-vc"
          v-for="(item, index) in personList.slice(1)"
          :key="index"
        >
          <div class="person-avatar">
            <img :src="item.photoImg" />
          </div>
          <div class="person-info flex-1">
            <div class="person-name">{{ item.visitorName }}</div>
            <div class="person-phone">{{ item.visitorPhone }}</div>
          </div>
          <div class="handle" @click="clickPersonMinus(index)">
            删除
          </div>
        </div>
      </div>
    </div> -->
    <updatePersinList :id="id" type="save" />
    <div style="padding: 2rem 1rem;">
      <van-row>
        <van-col :span="24">
          <van-button
            round
            type="info"
            block
            @click="clickSubmit"
            :disabled="subDisabled"
            :loading-text="subTextBtn"
            :loading="subDisabled"
            >提交暂存</van-button
          >
        </van-col>
        <!-- <van-col :span="12">
          <van-button
            round
            type="info"
            block
            @click="clickSubmit"
            :disabled="subDisabled"
            :loading-text="subTextBtn"
            :loading="subDisabled"
            >确认预约</van-button
          >
        </van-col> -->
      </van-row>
    </div>

    <!-- 拜访开始时间 -->
    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :minDate="startMinTime"
    />

    <!-- 拜访离开时间 -->
    <SelectTime
      ref="endtime"
      :typeTime="'选择结束时间'"
      @time="handleTimeEndConfirm"
      :minDate="endMinDate"
      :maxDate="endMaxTime"
      :currentDate="endCurTime"
    />

    <!-- 添加被访人 -->
    <Interviewee ref="interviewee" @selectItem="handleSelIntervieweeItem" />
  </div>
</template>

<script>
import moment from 'moment'
import { compare, getDateYMD, timeFormart } from '@/utils'
import * as validate from '@/utils/validate'
import { upload } from '@/utils/upload'
import Interviewee from '@/components/subScribePopup/interviewee'
import SelectTime from '@/components/subScribePopup/selectTime'
import updatePersinList from '@/components/subScribePopup/updatePersinList'
import { init } from '@/utils/wxSDK'

const paramsList = {
  visitorName: '',
  visitorPhone: '',
  visitorIdCrde: '',
  photoImg: '',
}
export default {
  components: {
    Interviewee,
    SelectTime,
    updatePersinList,
  },

  computed: {
    startMinTime() {
      return new Date()
    },
    endCurTime() {
      return new Date(moment(this.endMinDate).add(1, 'h'))
    },
    endMaxTime() {
      return new Date(moment(this.endMinDate).add(this.maxDuration, 'hours'))
    },
    id() {
      return this.$route.query.id
    },
  },
  data() {
    return {
      // showPersonPopup: false,

      paramsList: Object.assign(paramsList),
      maxDuration: 3,
      endMinDate: '',

      singleQuery: {
        // visitorType: '',
        initiatorName: '',
        visitorPhone: '',
        remark: '',
        visitorGoal: '',
        type: 0, // 0手动预约 1主动邀约邀约
        // startTime0:'',
        visitorBeginTime: '',
        visitorEndTime: '',
        carNumber: '',
        affiliatedUnit: '',
        // initiatorId: '', // 发起者id
        acceptName: '',
        acceptId: '', // 接受者id
        photoImg: '',
        // personnelMessageString:'0',// 0手动预约 1主动邀约邀约
      },
      addPersonFileList: [],
      curFileList: [],
      curType: '',
      // radioType: '',
      work: [],
      subDisabled: false,
      subTextBtn: '提交暂存',
      senseIDStatus: null,
    }
  },
  mounted() {
    this.getWork()
    this.getMaxDur()
    this.getSysSchool()
    // this.getWXConfig()
    this.getSubDetail()
    // this.getPersonList()
  },
  methods: {
    async getSubDetail() {
      const { data, code } = await this.$https.getVisitorDetail({
        visitorId: this.id,
      })
      if (code !== 200) {
        this.$toast('获取详情失败')
        return false
      }
      this.singleQuery = data
      this.singleQuery.visitorBeginTime = getDateYMD(data.visitorBeginTime)
      this.singleQuery.visitorEndTime = getDateYMD(data.visitorEndTime)
      // this.personList = []
      // this.personList.push({
      //   visitorName: data.initiatorName,
      //   visitorPhone: data.visitorPhone,
      //   visitorIdCrde: data.visitorIdCrde,
      //   photoImg: data.photoImg,
      // })
      this.curFileList.push({
        url: data.photoImg,
      })
      // console.log(data)
    },

    async getSysSchool() {
      const { data, code, msg } = await this.$https.getSysSchool({
        // dictType: 'school_function_param',
        schoolId: localStorage.getItem('schoolId'),
      })
      if (code !== 200) {
        // this.$toast('')
        return
      }
      this.senseIDStatus = data.some((item) => item.functionDictCode == 6)
    },
    clickBack() {
      this.$router.go(-1)
    },

    clickTime(type) {
      this.$refs[type].showTimePopup = true
    },
    clickSave() {
      // this.$router.push('/transientSave')
      // this.transienceSaveData()
    },

    handleSelIntervieweeItem(item) {
      // 更新被访人id
      this.$set(this.singleQuery, 'acceptId', item.id)
      this.$set(this.singleQuery, 'acceptName', item.name)
      this.$refs.interviewee.showiIntervieweePopup = false
    },

    handleTimeStartConfirm(value) {
      this.$set(this.singleQuery, 'visitorBeginTime', value)
      this.endMinDate = new Date(value.replace(/-/g, '/'))
      this.$refs.starttime.showTimePopup = false
    },

    handleTimeEndConfirm(value) {
      this.$set(this.singleQuery, 'visitorEndTime', value)
      this.$refs.endtime.showTimePopup = false
    },

    // async afterReadPerson(file) {
    //   try {
    //     const imgUrl = await upload(file.file)
    //     this.paramsList.photoImg = imgUrl
    //   } catch (error) {
    //     this.paramsList.photoImg = ''
    //     this.addPersonFileList = []
    //   }
    // },

    // beforeDelPerson(item, obj) {
    //   this.addPersonFileList.splice(obj.index, 1)
    // },

    async afterReadCur(file) {
      try {
        const imgUrl = await upload(file.file)
        console.log('上传图片成功啦---', imgUrl)
        this.personList[0].photoImg = imgUrl
      } catch (error) {
        this.personList[0].photoImg = ''
        this.curFileList = []
      }
    },

    beforeDelCur(item, obj) {
      console.log(obj)
      this.curFileList.splice(obj.index, 1)
      this.personList[0].photoImg = ''
    },

    changeRadioType(name) {
      this.singleQuery.visitorGoal = name
    },

    // clickPersonMinus(index) {
    //   this.personList.splice(index + 1, 1)
    // },

    clickSubmit() {
      if (this.validateForm()) {
        this.subTransienceSave()
      }
    },

    validateForm() {
      let errMsg = {
        visitorName: '姓名为空',
        visitorPhone: '手机号为空',
        photoImg: '请上传识别头像',
        visitorBeginTime: '请选择开始时间',
        visitorEndTime: '请选择离开时间',
        acceptId: '请选择被访人',
      }
      let objOther = this.singleQuery

      if (!objOther.initiatorName) {
        this.$toast(errMsg.visitorName)
        return false
      }
      if (!objOther.visitorPhone) {
        this.$toast(errMsg.visitorPhone)
        return false
      }
      if (!validate.isPhone(objOther.visitorPhone)) {
        this.$toast('手机号有误')
        return false
      }
      if (!objOther.photoImg) {
        this.$toast(errMsg.photoImg)
        return false
      }
      if (!objOther.visitorBeginTime) {
        this.$toast(errMsg.visitorBeginTime)
        return false
      }
      if (!objOther.visitorEndTime) {
        this.$toast(errMsg.visitorEndTime)
        return false
      }
      // if (!objOther.acceptId) {
      //   this.$toast(errMsg.acceptId)
      //   return false
      // }
      if (this.senseIDStatus) {
        if (!objOther.visitorIdCrde) {
          this.$toast('身份证号为空')
          return false
        }
      }
      // 离开时间大于开始时间
      if (
        moment(objOther.visitorEndTime).valueOf() -
          moment(objOther.visitorBeginTime).valueOf() <=
        0
      ) {
        this.$toast('离开时间不能小于开始时间')
        return false
      }
      if (objOther.visitorIdCrde) {
        if (!validate.isIdCard(objOther.visitorIdCrde)) {
          this.$toast('身份证号有误，请检查')
          return false
        }
      }
      if (objOther.carNumber) {
        if (!validate.isLicencePlate(objOther.carNumber)) {
          this.$toast('车牌号有误，请检查')
          return false
        }
      }

      return true
    },

    async getWork() {
      const { code, data } = await this.$https.getwork({
        dictType: 'visit_reason',
      })
      if (code !== 200) {
        this.$toast('获取预约事由失败')
        return
      }
      this.work = data
    },

    async getMaxDur() {
      await this.$https.getMaxDuration({
        schoolId: '1049061538447069184',
      })
    },

    async subTransienceSave() {
      try {
        this.subDisabled = true
        this.subTextBtn = '提交中...'
        const { visitorBeginTime, visitorEndTime, ...rest } = this.singleQuery
        const { code } = await this.$https.subTransienceSave({
          ...rest,
          visitorBeginTime: timeFormart(visitorBeginTime),
          visitorEndTime: timeFormart(visitorEndTime),
          initiatorId: this.$store.state.userId,
          schoolId: this.$store.state.schoolId,
          id: this.id,
          initiatorPhone: this.singleQuery.visitorPhone,
        })
        if (code !== 200) {
          this.$toast({
            type: 'fail',
            message: '提交失败，请重试！',
          })
          this.subDisabled = false
          this.subTextBtn = '提交暂存'

          return false
        }

        // this.$refs.subsuccess.showPopup = true
        this.$toast({
          type: 'success',
          overlay: true,
          message: '提交成功',
          duration: 1500,
          onClose: () => {
            this.$router.go(-1)
          },
        })
      } catch (error) {
        this.$toast({
          type: 'fail',
          message: '提交失败，请重试！',
        })
        this.subDisabled = false
        this.subTextBtn = '提交暂存'
      } finally {
        this.subDisabled = false
        this.subTextBtn = '提交暂存'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::deep .van-uploader__preview-image {
  border-radius: 50%;
}
.form-wrap {
  margin: 1rem;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
}
.add-person-wrap {
  background: #fff;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  height: 3.375rem;
  text-align: center;
  line-height: 3.375rem;
  margin: 1rem 1rem 0;
  border-radius: 0.75rem;
  font-size: 0.875rem;
  color: rgba(52, 151, 253, 1);
  .iconfont {
    font-size: 0.75rem;
    margin-right: 0.25rem;
  }
}

.person-list {
  margin: 1rem 1rem 0;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #ffffff;
  border-radius: 0.75rem;
  .person-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    > span {
      color: rgba(120, 132, 158, 1);
      font-size: 0.75rem;
    }
    > div {
      .iconfont {
        font-size: 0.75rem;
      }
      font-size: 0.875rem;
      color: rgba(52, 151, 253, 1);
    }
  }
  .person-item {
    padding: 1rem 0;
    margin: 0 1rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);
    margin-bottom: 0.6rem;
    .person-name {
      color: rgba(69, 79, 99, 1);
      font-size: 1rem;
      font-weight: 400;
      margin-bottom: 0.125rem;
    }
    .person-phone {
      color: rgba(120, 132, 158, 1);
      font-size: 0.875rem;
    }
    .person-avatar {
      margin-right: 1rem;
      img {
        width: 3rem;
        height: 3rem;
        border-radius: 0.75rem;
        margin: 0 auto;
        display: block;
      }
    }
    .handle {
      background: rgba(233, 235, 239, 1);
      border-radius: 0.5rem;
      font-size: 0.6875rem;
      width: 5rem;
      height: 2rem;
      text-align: center;
      line-height: 2rem;
      color: rgba(120, 132, 158, 1);
    }
  }
}
</style>
